import { useState } from "react";
import { MdClose } from "react-icons/md";
import "./TagsSection.css";

function TagsSection({
  formData,
  addTag,
  removeTag,
}) {
  const [tagInput, setTagInput] = useState("");

  const handleAddTag = () => {
    const value = tagInput.trim();

    if (!value) return;

    addTag(value);

    setTagInput("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="food-form-section">

      <h3 className="section-title">
        Food Tags
      </h3>

      <div className="tags-input">

        <input
          type="text"
          placeholder="Example: Spicy"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <button
          type="button"
          onClick={handleAddTag}
        >
          Add
        </button>

      </div>

      {formData.tags.length > 0 && (

        <div className="tags-list">

          {formData.tags.map((tag, index) => (

            <div
              key={index}
              className="tag-chip"
            >

              {tag}

              <button
                type="button"
                onClick={() => removeTag(index)}
              >
                <MdClose />
              </button>

            </div>

          ))}

        </div>

      )}

      <div className="tags-help">

        Examples:
        Spicy • Sweet • Healthy • Jain • Kids Special •
        High Protein • Sugar Free • Homemade

      </div>

    </div>
  );
}

export default TagsSection;